<template>
  <b-card-actions :title="title">
    <div class="card-body">
      <swiper
        class="swiper-centered-slides p-0"
        :options="swiperOptions"
        v-if="items.length > 0"
      >
        <!-- slides -->
        <swiper-slide
          v-for="item in items"
          :key="item.id"
          class="rounded swiper-shadow"
        >
          <div class="row align-items-center px-5">
            <div class="col-12 content-d">
              <div class="row">
                <a @click="open(item, title)">
                  <h2 class="col d-inline-flex align-items-center">
                    {{ item.title }}
                  </h2>
                </a>
                <h6 class="col d-inline-flex align-items-center">
                  بواسطة : {{ item.user ? item.user.full_name : "" }}
                </h6>
                <h6 class="col d-inline-flex align-items-center">
                  تم الارسال بتاريخ : {{ item.publish_date }}
                </h6>
              </div>
            </div>
          </div>
        </swiper-slide>

        <!-- Add Arrows -->
        <!-- <div slot="button-next" class="swiper-button-next"></div> -->
        <feather-icon
          slot="button-next"
          class="swiper-button-prev"
          :icon="locale == 'ar' ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
          size="30"
        />
        <!-- <div slot="button-prev" class="swiper-button-prev" /> -->
        <feather-icon
          slot="button-prev"
          class="swiper-button-next"
          :icon="locale == 'ar' ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
          size="30"
        />
      </swiper>
      <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
    </div>
    <b-modal id="modal-2" v-if="type == 'announcement'" hide-footer>
      <template #modal-title> {{ data.title }} </template>
      <div class="d-block text-center">
        <h3 v-html="data.content"></h3>
      </div>
    </b-modal>
    <b-modal id="modal-1" size="lg" v-if="type == 'poll'" hide-footer>
      <template #modal-title v-if="!load"> {{ data.poll.title }} </template>
      <div v-if="!load">
        <div
          class="d-block text-center"
          v-for="question in data.pollQuestion"
          :key="question.id"
        >
          <h3>{{ question.question }}</h3>
          <hr />

          <h4 v-html="question.description"></h4>
          <hr />
          <b-list-group v-if="data.answer == 0">
            <b-list-group-item
              class="d-flex"
              v-for="answer in question.poll_answer"
              :key="answer.id"
            >
              <b-form-radio
                v-model="answerids"
                :name="`some-radios-${data.poll}`"
                :value="answer.id"
                @change="setAnswer"
              >
                {{ answer.answer }}
              </b-form-radio>
            </b-list-group-item>
          </b-list-group>
          <div v-else>
            <char-polar-area-poll-vue
              :data="dataAnswer[question.id]"
              :labels="labelsAnswer[question.id]"
              :title="question.question"
            />
          </div>
        </div>
      </div>
      <b-spinner v-else type="grow" label="Loading..."  class="loading" />
    </b-modal>
  </b-card-actions>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import PollsController from "@/Controllers/PollsController";
import CharPolarAreaPollVue from "../../Polls/components/CharPolarAreaPoll.vue";

export default {
  props: {
    items: [],
    title: String,
    type: String,
  },
  components: {
    Swiper,
    BCardActions,

    SwiperSlide,
    CharPolarAreaPollVue,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 30,
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
      },
      data: {},
      load: false,
      answerids: [],
      labelsAnswer: [],
      dataAnswer: [],
      locale: "ar",
    };
  },
  created() {
    let locale = localStorage.getItem("locale");
    if (locale) this.locale = locale;
  },
  methods: {
    async open(item) {
      if (this.type == "announcement") {
        this.data = item;
        this.$bvModal.show("modal-2");
      }
      if (this.type == "poll") {
        this.$bvModal.show("modal-1");
        this.load = true;
        let poll = await new PollsController().GetPoll(item.id);

        this.data = poll;
        if (this.data.answer == 1) {
          this.data.pollQuestion.forEach((question) => {
            this.labelsAnswer[question.id] = question.poll_answer.map(
              (a) => a.answer
            );
            this.dataAnswer[question.id] = question.poll_answer.map(
              (a) => a.votes
            );
          });
        }
        this.load = false;
      }
    },
    setAnswer() {
      new PollsController().SetPoll({
        answerids: this.answerids,
        pollId: this.data.poll.id,
      });
    },
  },
};
</script>
